var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "block_stats"
  }, [_c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Block Height "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the number of ancestor blocks."
    }
  })], 1), _c('div', {
    staticClass: "meta_value"
  }, [_c('div', {
    staticClass: "block_link"
  }, [parseInt(_vm.block.blockNumber) > 0 ? _c('router-link', {
    attrs: {
      "to": {
        path: "/evmblock/".concat(parseInt(_vm.block.blockNumber) - 1),
        query: {
          network: _vm.DEFAULT_NETWORK_NAME,
          subnet: _vm.subnetName ? _vm.subnetName : ''
        }
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref) {
        var on = _ref.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-left",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }], null, false, 1999135174)
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(parseInt(_vm.block.blockNumber) - 1) + " ")])])])], 1) : _vm._e()], 1), _vm._v(" " + _vm._s(_vm.block.blockNumber) + " "), _vm.latestBlockNumber !== _vm.block.blockNumber ? _c('div', {
    staticClass: "block_link"
  }, [_c('router-link', {
    attrs: {
      "to": {
        path: "/evmblock/".concat(parseInt(_vm.block.blockNumber) + 1),
        query: {
          network: _vm.DEFAULT_NETWORK_NAME,
          subnet: _vm.subnetName ? _vm.subnetName : ''
        }
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "top": ""
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function fn(_ref2) {
        var on = _ref2.on;
        return [_c('fa', _vm._g({
          attrs: {
            "icon": "arrow-right",
            "color": "#c4c4c4"
          }
        }, on))];
      }
    }], null, false, 2440273853)
  }, [_c('div', [_c('p', [_vm._v(" " + _vm._s(parseInt(_vm.block.blockNumber) + 1) + " ")])])])], 1)], 1) : _vm._e()])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Accepted "), _c('Tooltip', {
    attrs: {
      "content": "This block's inception date and time."
    }
  })], 1), _c('div', {
    staticClass: "meta_value"
  }, [_c('p', {
    staticClass: "date"
  }, [_c('fa', {
    staticClass: "time_icon",
    attrs: {
      "icon": ['far', 'clock']
    }
  }), _c('span', {
    staticClass: "timestamp"
  }, [_vm._v(_vm._s(_vm._f("fromNow")(parseInt(_vm.block.header.timestamp))) + " (" + _vm._s(_vm.date.toUTCString()) + ")")])], 1)])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Transactions "), _c('Tooltip', {
    attrs: {
      "content": "Total number of transactions"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm.block.transactions.length === 0 ? [_vm._v("There are no transactions for this block. ")] : [_vm._v(" " + _vm._s(_vm._f("pluralize")(_vm.block.transactions.length, 'transaction')) + " ")]], 2)]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Difficulty "), _c('Tooltip', {
    attrs: {
      "content": "The difficulty level of this block"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(parseInt(_vm.block.header.difficulty)) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Total Difficulty "), _c('Tooltip', {
    attrs: {
      "content": "Total difficulty level of this block"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(parseInt(_vm.block.header.totalDifficulty).toLocaleString('en-US')) + " ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Size "), _c('Tooltip', {
    attrs: {
      "content": "Transaction block size"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(parseInt(_vm.block.header.size).toLocaleString()) + " bytes ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Used "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the total gas used by all transactions in this block."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.header.gasUsed.toLocaleString('en-US')) + " (" + _vm._s(_vm.gas.toPrecision(2)) + "%) gas ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Gas Limit "), _c('Tooltip', {
    attrs: {
      "content": "A scalar value equal to the current limit of gas expenditure per block."
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(parseInt(_vm.block.header.gasLimit).toLocaleString('en-US')) + " gas ")])]), _c('article', {
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Base Fee Per Gas "), _c('Tooltip', {
    attrs: {
      "content": "Base fee per gas"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(_vm._s(_vm.baseFeePerGas) + " nDCM")])]), _c('transition-group', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_vm.moreDetails ? _c('article', {
    key: "1",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Hash "), _c('Tooltip', {
    attrs: {
      "content": "Current block hash"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.header.hash) + " "), _c('CopyText', {
    attrs: {
      "value": _vm.block.header.hash
    }
  })], 1)]) : _vm._e(), _vm.moreDetails && parseInt(_vm.block.header.parentHash) !== 0 ? _c('article', {
    key: "2",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Parent Hash "), _c('Tooltip', {
    attrs: {
      "content": "Previous block hash"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_c('router-link', {
    staticClass: "link",
    attrs: {
      "to": _vm.hasSubnet ? {
        path: "/evmblock/".concat(_vm.block.header.parentHash),
        query: {
          network: _vm.DEFAULT_NETWORK_NAME,
          subnet: _vm.subnetName
        }
      } : {
        path: "/evmblock/".concat(_vm.block.header.parentHash),
        query: {
          network: _vm.DEFAULT_NETWORK_NAME
        }
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.block.header.parentHash) + " ")]), _c('CopyText', {
    attrs: {
      "value": _vm.block.header.parentHash
    }
  })], 1)]) : _vm._e(), _vm.moreDetails ? _c('article', {
    key: "3",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Sha3Uncles "), _c('Tooltip', {
    attrs: {
      "content": "Uncles are blocks found by a miner, \n                when a different miner has already found another block for the corresponding \n                place in the blockchain. They are also known as 'stale blocks'"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(_vm.block.header.sha3Uncles) + " "), _c('CopyText', {
    attrs: {
      "value": _vm.block.header.sha3Uncles
    }
  })], 1)]) : _vm._e(), _vm.moreDetails ? _c('article', {
    key: "4",
    staticClass: "meta_row"
  }, [_c('p', {
    staticClass: "meta_label"
  }, [_vm._v(" Nonce "), _c('Tooltip', {
    attrs: {
      "content": "64 bit hash which proves combined with the mix-hash that a sufficient amount of computation has been carried out on this block"
    }
  })], 1), _c('div', {
    staticClass: "meta_value values"
  }, [_vm._v(" " + _vm._s(parseInt(_vm.block.header.nonce)) + " ")])]) : _vm._e()]), _c('span', {
    staticClass: "more",
    on: {
      "click": _vm.toggleMore
    }
  }, [!_vm.moreDetails ? _c('span', [_vm._v("Click to see more")]) : _c('span', [_vm._v("Click to hide")]), _vm.moreDetails === false ? _c('fa', {
    attrs: {
      "icon": "arrow-down"
    }
  }) : _c('fa', {
    attrs: {
      "icon": "arrow-up"
    }
  })], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }